import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
const APost = ({ post, index }) => {
    const [className, setClassName] = useState('c-a-post');
    useEffect(() => {
        if (index % 2 === 0) {
            setClassName('c-a-post right');
        }
        else {
            setClassName('c-a-post left');
        }
    }, [
        index
    ]);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "c-a-post-main" },
            React.createElement("div", { className: "c-a-post-username" },
                post.name,
                "\u3055\u3093"),
            React.createElement("div", { className: "c-a-post-grid" },
                React.createElement("div", { className: "c-a-post-grid-twitter" }, parse(post.alt)),
                React.createElement("div", { className: "c-a-post-grid-comment" },
                    React.createElement("div", { className: "c-a-post-grid-comment-icon" },
                        React.createElement("img", { src: `./assets/img/report/icon/mosyne/r.png` }),
                        React.createElement("img", { src: `./assets/img/report/icon/mosyne/l.png` })),
                    React.createElement("div", { className: "c-a-post-grid-comment-text" }, post.comment))))));
};
export default APost;
